module.exports = __webpack_public_path__ + "static/media/ic_ubicacion_blanco.aecbe256.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_ubicacion_blanco.webp
// module id = 194
// module chunks = 1